/**
 * Relationship stages (PRD §5.5).
 *
 * Separate from `RelationshipStageBadge.tsx` so that file exports only a
 * component — a module mixing components and constants defeats fast refresh.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.3, PRD §5.5
 */

/** How far a commercial relationship has got. */
export const RELATIONSHIP_STAGES = [
  'PROSPECT',
  'ENGAGED',
  'NDA_SIGNED',
  'PILOT_HOST',
  'COMMERCIAL_CUSTOMER',
  'DORMANT',
] as const;

export type RelationshipStage = (typeof RELATIONSHIP_STAGES)[number];

/**
 * Dot colour per stage.
 *
 * The five progressing stages walk the same green→navy ramp the startup funnel
 * uses, so "further along" reads the same way across the product. `DORMANT`
 * steps outside it — it is not a position on that path but a departure from it,
 * and colouring it as a late stage would read as progress.
 */
export const RELATIONSHIP_STAGE_DOT: Record<RelationshipStage, string> = {
  PROSPECT: 'bg-stage-1',
  ENGAGED: 'bg-stage-3',
  NDA_SIGNED: 'bg-stage-4',
  PILOT_HOST: 'bg-stage-5',
  COMMERCIAL_CUSTOMER: 'bg-stage-7',
  DORMANT: 'bg-stage-parked',
};
